"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard3(require("react"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Fallback = function Fallback(props) {
  return (0, _core.jsx)("svg", props);
};

var Icon = function Icon(props) {
  var type = props.type,
      other = (0, _objectWithoutProperties2.default)(props, ["type"]);
  var FallbackIcon = (0, _core.jsx)(_Icon.default, (0, _extends2.default)({
    as: Fallback
  }, other));
  var IconType = (0, _react.useMemo)(function () {
    switch (type) {
      case 'Close':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Close'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Logistic':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Logistic'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Service':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Service'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'CashBatch':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/CashBatch'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Company':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Company'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'CalendarFrom':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/CalendarFrom'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'CalendarTo':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/CalendarTo'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'User':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/User'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Friends':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Friends'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Follow':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Follow'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Atm':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Atm'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Search':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Search'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Clock':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Clock'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'PhoneShake':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/PhoneShake'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'CardHeart':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/CardHeart'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Alert':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Alert'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Branch':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Branch'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Factory':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Factory'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Home':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Home'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'JudicialScales':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/JudicialScales'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ChevronDoubleUp':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/ChevronDoubleUp'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ChevronDoubleDown':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/ChevronDoubleDown'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Send':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Send'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Username':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Username'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'PhoneCall':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/PhoneCall'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ServiceCounter':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/ServiceCounter'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Hammer':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Hammer'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Package':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Package'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'List':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/List'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'MapPinAlternate':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/MapPinAlternate'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Burger':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Burger'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Calculator':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Calculator'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Dialogue':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Dialogue'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Rocket':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Rocket'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Happy':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Happy'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Heart':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Heart'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Bell':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Bell'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'PlaybackPlayButton':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/PlaybackPlayButton'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'PlaybackPause':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/PlaybackPause'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'PlaybackPlay':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/PlaybackPlay'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'CircleCheckmark':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/CircleCheckmark'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Laptop':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Laptop'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Cash':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Cash'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Briefcase':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Briefcase'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'FirstAid':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/FirstAid'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Gavel':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Gavel'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'CashRegister':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/CashRegister'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Truck':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Truck'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'FirstAidKit':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/FirstAidKit'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Shop':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Shop'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'MapPin':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/MapPin'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ChevronDown':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/ChevronDown'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ChevronLeft':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/ChevronLeft'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ChevronUp':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/ChevronUp'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Add':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Add'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ThumbsUp':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/ThumbsUp'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'News':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/News'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'Checkmark':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/Checkmark'));
          });
        }, {
          fallback: FallbackIcon
        });

      case 'ArrowLeft':
        return (0, _component.default)(function () {
          return Promise.resolve().then(function () {
            return (0, _interopRequireWildcard2.default)(require('../Icons/ArrowLeft'));
          });
        }, {
          fallback: FallbackIcon
        });

      default:
        return Fallback;
    }
  }, [type]);

  if (!type) {
    return null;
  }

  return (0, _core.jsx)(_Icon.default, (0, _extends2.default)({
    as: IconType
  }, other));
};

__signature__(Icon, "useMemo{IconType}");

var _default = Icon;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Fallback, "Fallback", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/Icon.tsx");
  reactHotLoader.register(Icon, "Icon", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/Icon.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Cta/Icon.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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